import SearchBar from 'components/controls/search-bar';
import { useEffect, useRef, useState } from 'react';
import type { ChangeEventHandler } from 'react';

const SearchWrapper = ({
	baseUrl,
	placeholder,
	onChange,
	onSearchSubmit,
	searchText,
}: Props) => {
	const searchRef = useRef<HTMLInputElement | null>(null);
	const formRef = useRef<HTMLFormElement | null>(null);
	const [isSearching, setIsSearching] = useState(false);

	const handleSearch = () => {
		const searchTerm = searchRef.current?.value ?? searchText;

		setIsSearching(true);
		onSearchSubmit?.({
			searchTerm,
		});
		formRef.current.submit();
	};

	useEffect(() => {
		searchRef?.current?.focus();
	}, []);

	return (
		<form ref={formRef} action={baseUrl} method="GET">
			<SearchBar
				name={'q'}
				inputRef={searchRef}
				debounceTimeout={0}
				placeholderText={placeholder || 'What would you like to find?'}
				onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
				isSearching={isSearching}
				onButtonClick={handleSearch}
				initialQuery={searchText}
				onChange={onChange}
			/>
		</form>
	);
};

export default SearchWrapper;

interface Props {
	placeholder?: string;
	baseUrl: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	onSearchSubmit?: (props: { searchTerm?: string }) => void;
	searchText?: string;
}
